import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "static-datetime" }

import { getCanonicalLocale, getLanguage, t } from '@nextcloud/l10n'
import { useFormatTime } from '@nextcloud/vue/composables/useFormatDateTime'
import { computed } from 'vue'
import { getDiffInDays, getRelativeDay } from '../../utils/formattedTime.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'StaticDateTime',
  props: {
    time: {},
    calendar: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const isValidDate = computed(() => !isNaN(new Date(props.time).valueOf()))

const absoluteDateOptions = computed(() => {
	const date = new Date(+props.time)
	const isSameYear = date.getFullYear() === new Date().getFullYear()
	const diffInDays = getDiffInDays(date)

	const locale = props.calendar ? getCanonicalLocale() : getLanguage()
	const format: Intl.DateTimeFormatOptions = {
		dateStyle: undefined,
		timeStyle: undefined,
	}

	if (props.calendar && Math.abs(diffInDays) <= 6) {
		// Show weekday and time for nearest 6 days
		format.hour = 'numeric'
		format.minute = 'numeric'
	} else {
		format.year = !isSameYear ? 'numeric' : undefined
		format.month = 'long'
		format.day = 'numeric'
	}

	return { locale, format }
})
const absoluteDate = useFormatTime(+props.time, absoluteDateOptions)

/**
 * Generate the date header between the messages, like "Today, November 11", "3 days ago, November 8", "November 5, 2024"
 */
const datetimeString = computed(() => {
	if (!isValidDate.value) {
		// Custom string, pass as-is
		return props.time
	}

	const relativeDate = getRelativeDay(+props.time, { limitToWeek: true, showWeekDay: props.calendar })

	if (relativeDate) {
		// TRANSLATORS: <Today>, <March 18, 2024>
		return t('spreed', '{relativeDate}, {absoluteDate}', { relativeDate, absoluteDate: absoluteDate.value }, {
			escape: false, // French "Today" has a `'` in it
		})
	} else {
		return absoluteDate.value
	}
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(datetimeString.value), 1))
}
}

})